var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllProjects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 94,
    height: 60,
    viewBox: "0 0 94 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mask",
    d: "M0,0H94V60H0Z",
    transform: "translate(164 226)",
    fill: "#c7cdd1",
    opacity: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "all_projects_-_merchants",
    "data-name": "all projects - merchants",
    transform: "translate(-164 -226)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32357",
    "data-name": "Group 32357",
    transform: "translate(194.268 234.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34521",
    "data-name": "Path 34521",
    d: "M0,4.658V42.79H28.994V38.6H3.688l0-33.939Z",
    transform: "translate(0 0.081)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34522",
    "data-name": "Path 34522",
    d: "M6.183,0V36.61H33.658V7.321l-.031,0H26.3V0Z",
    transform: "translate(0.107)",
    fill: "#5048bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34523",
    "data-name": "Path 34523",
    d: "M28.2,5.046h5.044L28.2,0Z",
    transform: "translate(0.489 0)",
    fill: "#002c77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllProjects);
export default __webpack_public_path__ + "static/media/all_projects.f7cd37cc90bd9fce978c96da544a5cf2.svg";
export { ForwardRef as ReactComponent };